// extracted by mini-css-extract-plugin
export default {"clientList":"ClientVisits_clientList__0mM5E","clientName":"ClientVisits_clientName__3oKH6","noLocation":"ClientVisits_noLocation__C2jz7"};